import { Stack } from 'expo-router';
import React from 'react';

function OpenSavingsLayout() {
  return <Stack />;
}

export default OpenSavingsLayout;
